<div class="login-wrapper">
  <main class="login-card split">

    <!-- ============ Left: Brand panel (decorative) ============ -->
    <section class="left-panel" aria-hidden="true">

      <!-- faint scattered PMS icons in the background -->
      <div class="panel-bg-icons">
        <i class="fa-solid fa-diagram-project bg-ico i1"></i>
        <i class="fa-solid fa-list-check bg-ico i2"></i>
        <i class="fa-solid fa-chart-column bg-ico i3"></i>
        <i class="fa-regular fa-clock bg-ico i4"></i>
        <i class="fa-solid fa-bug bg-ico i5"></i>
        <i class="fa-regular fa-calendar-check bg-ico i6"></i>
      </div>

      <div class="overlay">
        <span class="brand"></span>

        <div class="panel-copy">
          <!--<p class="tagline">Sign in to manage your projects, teams and timelines.</p>-->
          <h4 class="welcome">Oasys PMS</h4>
          <!-- PMS feature icon chips -->
          <div class="panel-icons">
            <div class="icon-chip c1">
              <i class="fa-solid fa-diagram-project"></i>
              <span>Boards</span>
            </div>
            <div class="icon-chip c2">
              <i class="fa-solid fa-list-check"></i>
              <span>Tasks</span>
            </div>
            <div class="icon-chip c3">
              <i class="fa-regular fa-clock"></i>
              <span>Timesheets</span>
            </div>
            <div class="icon-chip c4">
              <i class="fa-solid fa-chart-column"></i>
              <span>Analytics</span>
            </div>
          </div>
        </div>

        <span class="panel-footnote">Project Management System</span>
      </div>
    </section>

    <!-- ============ Right: Login form ============ -->
    <section class="right-panel">

      <div class="logo-section">
        <img src="assets/512X512.png" alt="OASYS PMS logo" width="200" height="200" />
      </div>

      <header class="form-header">
        <h2>Welcome back</h2>
      </header>

      <form [formGroup]="loginForm" (ngSubmit)="onLogin()" novalidate>

        <!-- Username -->
        <div class="form-group">
          <label for="username"></label>
          <input id="username" type="text" placeholder="Enter your username" autocomplete="username"
            autocapitalize="none" autocorrect="off" spellcheck="false" autofocus formControlName="username"
            [class.is-invalid]="loginForm.get('username')?.invalid && loginForm.get('username')?.touched"
            [attr.aria-invalid]="loginForm.get('username')?.invalid && loginForm.get('username')?.touched" />

          <p class="field-error"
            *ngIf="loginForm.get('username')?.hasError('required') && loginForm.get('username')?.touched">
            Username is required.
          </p>
        </div>

        <!-- Password -->
        <div class="form-group password-field">
          <label for="password"></label>

          <div class="password-input">
            <input id="password" [type]="showPassword ? 'text' : 'password'" placeholder="Enter your password"
              autocomplete="current-password" formControlName="password"
              [class.is-invalid]="loginForm.get('password')?.invalid && loginForm.get('password')?.touched"
              [attr.aria-invalid]="loginForm.get('password')?.invalid && loginForm.get('password')?.touched" />

            <button type="button" class="toggle-visibility" (click)="togglePassword()"
              [attr.aria-label]="showPassword ? 'Hide password' : 'Show password'" [attr.aria-pressed]="showPassword">
              <i class="fa" [ngClass]="showPassword ? 'fa-eye' : 'fa-eye-slash'" aria-hidden="true"></i>
            </button>
          </div>

          <p class="field-error"
            *ngIf="loginForm.get('password')?.hasError('required') && loginForm.get('password')?.touched">
            Password is required.
          </p>
        </div>

        <!-- Optional: change password link (uncomment when needed)
        <div class="forgot-password">
          <span (click)="goToChangePassword()">Change password?</span>
        </div>
        -->

        <!-- Optional: captcha (uncomment when needed)
        <div class="form-group captcha-group">
          <div class="captcha-box">
            <span>QA-77</span>
            <button type="button" aria-label="Refresh captcha">&#8635;</button>
          </div>
          <input type="text" placeholder="Enter captcha" formControlName="captcha" />
        </div>
        -->
        <div class="forgot-password">
          <button type="button" class="forgot-btn" (click)="goToForgotPassword()">
            Forgot Password?
          </button>
        </div>
        <button type="submit" class="btn login-btn" [disabled]="loginForm.invalid">
          Login
        </button>

      </form>

      <footer class="form-footer">
        <span>&copy; 2026 OASYS PMS &middot; All rights reserved</span>
      </footer>

    </section>

  </main>
</div>